<template>
  <div class="viewport-root">
    <component :is="layoutcomponent"></component>
    <ApiErrorToast />
  </div>
</template>
<script setup>
import DefaultLayout from '@/layouts/default.vue';
import EmptyLayout from './layouts/empty.vue';
import ApiErrorToast from '@/shared/components/ApiErrorToast.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useDisplayScale } from '@/composables/useDisplayScale.js';

// 啟動時套用使用者儲存的顯示比例
useDisplayScale();

const layoutByKey = {
  default: DefaultLayout,
  empty: EmptyLayout,
};

const route = useRoute();
const layoutcomponent = computed(
  () => layoutByKey[route.meta.layout] || layoutByKey.default,
);
</script>
<script>
export default {
  name: 'App',
};
</script>
<style>
.viewport-root {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
}
</style>
